// extracted by mini-css-extract-plugin
module.exports = {"waldorfSpecification":"style_waldorfSpecification__wSYam","waldorfTabElement":"style_waldorfTabElement__VGMwW","activeLink":"style_activeLink__Aqm_Q"};